module.exports = __webpack_public_path__ + "img/collection-engagementRingsCordial.69acf48.jpg";